<template>
  <div>
    <v-alert
      timeout="6000"
      dense
      dismissible
      v-if="successMessage != ''"
      type="success"
    >
      {{ successMessage }}
    </v-alert>
    <v-alert
      dismissible
      dense
      v-if="errorMessage != '' && errorMessage"
      type="error"
    >
      {{ errorMessage }}
    </v-alert>
  </div>
</template>

<script>
import * as fun from "../plugins/common";
import axios from "axios";
export default {
  name: "CustomerPortal",
  components: {},
  props: {},
  data() {
    return {
      portalId: 0,
      customerId: "",
      successMessage: "",
      errorMessage: "",
      customer: null,
    };
  },
  mounted() {
    // var customerId = this.$route.params.id;
    this.decryptId();
    var loginData = {
      portal_id: this.portalId,
      customer_id: this.customerId,
    };
    axios
      .post(this.serverURL + "/customer_login", loginData)
      .then((response) => {
        console.log(response);
        if (response.data == "not exist") {
          this.errorMessage = "Customer does not exist";
        } else {
          this.$root.isCustomer(true);
          this.customer = response.data;
          this.successMessage =
            "Welcome " +
            this.customer.contact.first_name +
            " " +
            this.customer.contact.last_name;
        }
        // console.log(this.$store.state.auth.isCustomerAuthenticated);
        // if (this.$store.state.auth.isCustomerAuthenticated) {
        //   // if (this.$router.currentRoute.path !== "/") {
        //   //   this.$router.push("/");
        //   // }
        //   this.$root.$emit("customerLoginSuccessful");
        // }
      });
  },
  beforeDestroy() {},
  methods: {
    decryptId() {
      var msg = this.$parent.$router.currentRoute.params.id;
      this.decr = fun.decrypt(msg, this.passPhrase);
      var portalId = this.decr.split(":")[0];
      this.portalId = "emover_" + portalId;
      // this.portalId = "portal_" + portalId;
      this.customerId = this.decr.split(":")[1];
    },
  },
};
</script>

<style lang="css" scoped></style>
